import FlexContainer from 'components/common/FlexContainer';
import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Text = styled.span({
  lineHeight: '20px',
});

export const Caption = styled(Text)({
  color: fontStyles.colors.tertiary,
});

export const Container = styled(FlexContainer)({
  flexDirection: 'row',
  gap: 60,
  [mobileMediaQuery]: {
    flexDirection: 'column',
    gap: 40,
    margin: '0px 20px',
  },
});
